(() => {
  const isValidHandle = handle => (
    typeof handle === 'string' &&
    /^[a-z0-9][a-z0-9-]*$/i.test(handle)
  );
  window.NodixCatalog = {
    has: handle => isValidHandle(handle),
    readSavedHandles(key) {
      try {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        const filtered = Array.isArray(stored)
          ? [...new Set(stored)].filter(isValidHandle)
          : [];
        localStorage.setItem(key, JSON.stringify(filtered));
        return filtered;
      } catch {
        return [];
      }
    },
  };
})();
